export const SECTIONS = [
  {
    name: 'sections',
    items: ['territories', 'actions', 'draft-actions', 'layers']
  },
  {
    name: 'parametricTables',
    items: ['priorizaciones', 'disclaimers', 'studies','etapas', 'themes', 'subthemes', 'chart-categories', 'subtheme-categories', 'types', 'scopes', 'terms', 'sources', 'financiadores-estudios', 'paises', 'metrics', 'metric-values']
  }
];
